<script>
  export default {
    computed: {
      currentCompany () {
        return this.$store.getters['authentication/selectedCompany']
      }
    },
    watch: {
      currentCompany (company, oldValue) {
        if (oldValue !== company) {
          this.updateCompany()
        }
      }
    },
    methods: {
      updateCompany () {
        const company = this.currentCompany
        if (!company) {
          return
        }
        this.$store.dispatch(this.store + '/updateItem', { company: company['@id'] })
      },
      // FIXME: this relies upon view-land to call "reset" upon resetting.
      resetted () {
        this.updateCompany()
      }
    }
  }
</script>
